<script lang="ts">
	import { goto } from '$app/navigation';
	import WidgetPage from '#lib/widget/components/WidgetPage.svelte';
	import { widgetConfig } from '#lib/widget/core.js';
	import { onMount } from 'svelte';

	onMount(() => {
		goto(`/widget/${$widgetConfig.hash}/giftcards/select`);
	});
</script>

<WidgetPage />
